import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import AppLayout from "@/layouts/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Vacation from "@/pages/Vacation";
import Documents from "@/pages/Documents";
import Todos from "@/pages/Todos";
import TimeTracking from "@/pages/TimeTracking";
import Notifications from "@/pages/Notifications";
import AuditLog from "@/pages/AuditLog";
import Profile from "@/pages/Profile";
import Feedback from "@/pages/Feedback";
import Appointments from "@/pages/Appointments";

function Protected() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-sky-700 animate-pulse" />
          <span>Lade…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AdminOnly() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route element={<AdminOnly />}>
                <Route path="/mitarbeiter" element={<Employees />} />
                <Route path="/audit-log" element={<AuditLog />} />
              </Route>
              <Route path="/mitarbeiter/:id" element={<EmployeeDetail />} />
              <Route path="/urlaub" element={<Vacation />} />
              <Route path="/dokumente" element={<Documents />} />
              <Route path="/aufgaben" element={<Todos />} />
              <Route path="/zeiterfassung" element={<TimeTracking />} />
              <Route path="/termine" element={<Appointments />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/benachrichtigungen" element={<Notifications />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
